import { render, staticRenderFns } from "./CheckAgentModal.vue?vue&type=template&id=2b59967a&"
import script from "./CheckAgentModal.vue?vue&type=script&lang=js&"
export * from "./CheckAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports